import s from './InputsGroup.module.scss';
import Label from '@/app/components/ui/inputs/Input/Label';

const InputsGroup = ({
  children,
  label,
  error,
  number,
  name,
  required,
  isOnDark = false,
}) => {
  return (
    <div className={`${s.groupWrapper} ${s[isOnDark ? 'isOnDark' : '']}`}>
      {label && (
        <Label
          number={number}
          htmlFor={name}
          required={required}
          hasError={error}
        >
          {label}
        </Label>
      )}
      <div className={s.group}>{children}</div>
      {error && <span className={s.errorMessage}>{error}</span>}
    </div>
  );
};

export default InputsGroup;
